/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type fetchPublicKeyQueryVariables = {};
export type fetchPublicKeyQueryResponse = {
    readonly jwtPublicKey: string | null;
};
export type fetchPublicKeyQuery = {
    readonly response: fetchPublicKeyQueryResponse;
    readonly variables: fetchPublicKeyQueryVariables;
};



/*
query fetchPublicKeyQuery {
  jwtPublicKey
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jwtPublicKey",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchPublicKeyQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "fetchPublicKeyQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fb79def9df36347767dd028e030fe963",
    "id": null,
    "metadata": {},
    "name": "fetchPublicKeyQuery",
    "operationKind": "query",
    "text": "query fetchPublicKeyQuery {\n  jwtPublicKey\n}\n"
  }
};
})();
(node as any).hash = 'f09b588f1f26cf1132fc1461f62d6f71';
export default node;
